import { DeleteVendorAPIResponse, BaseReducerState } from '../../../services'
import { ActionTypes } from '../actions'

export type DeleteVendorState = BaseReducerState & {
  data: null
}

export const initialState: DeleteVendorState = {
  loading: false,
  success: false,
  message: '',
  data: null,
  error: null,
}

export const deleteVendorReducer = (
  state: DeleteVendorState = initialState,
  action: { type: string; res: any }
): DeleteVendorState => {
  switch (action.type) {
    case `${ActionTypes.DELETE_VENDOR}_REQUEST`:
      return {
        ...state,
        loading: true,
        success: false,
        message: null,
        data: null,
        error: null,
      }

    case `${ActionTypes.DELETE_VENDOR}_SUCCESS`: {
      const { success, data, message } = <DeleteVendorAPIResponse>action.res
      return {
        ...state,
        loading: false,
        success,
        message,
      }
    }
    case `${ActionTypes.DELETE_VENDOR}_FAILURE`: {
      const res = <DeleteVendorAPIResponse>action.res
      const { message } = res || {}
      if (res) (res as any).error = (res as any).error ?? message
      const { error } = (res || {}) as any
      return {
        ...state,
        loading: false,
        success: false,
        message,
        error,
      }
    }

    case `${ActionTypes.DELETE_VENDOR}_RESET`:
      return {
        ...initialState,
      }
  }
  return state
}
